import Call from '../Call';
import {objToQs} from '../Utils';

const NetworkPerformance = {
    get(filters) {
        return Call(`networkPerformance?${objToQs(filters)}`);
    }
}

export default NetworkPerformance;


// WEBPACK FOOTER //
// ./src/services/API/components/NetworkPerformance.js